<template>
  <div class="card-root" @click="$emit('click')" :class="{ mobile: isMobileScan }">
    <div class="scanner-icon-wrapper">
      <template v-if="isMobileScan">
        <img
          class="absolute centered md:w-1/3"
          src="../../assets/Discovery/mobile-scan.svg"
          alt="Mobile Scan"
        />
      </template>
      <template v-else>
        <img
          class="absolute top-0 left-0"
          src="../../assets/Discovery/sensor_light.svg"
          alt="Sensor"
        />
        <img
          class="absolute top-0 right-0"
          src="../../assets/Discovery/sensor_light.svg"
          alt="Sensor"
        />
        <img
          class="absolute bottom-0 left-0"
          src="../../assets/Discovery/sensor_light.svg"
          alt="Sensor"
        />
        <img
          class="absolute bottom-0 right-0"
          src="../../assets/Discovery/sensor_light.svg"
          alt="Sensor"
        />
        <img
          v-if="isFootScanner"
          class="absolute centered md:w-1/2"
          src="../../assets/Discovery/foot.svg"
          alt="Human"
        />
        <img
          v-else
          class="absolute centered md:w-1/3"
          src="../../assets/Discovery/human_body.svg"
          alt="Human"
        />
      </template>
    </div>
    <div class="scanner-type">
      {{ scannerTypeText }}
    </div>
    <div class="scanner-name">{{ scanner.name }}</div>
    <div v-if="isMobileScan" class="scanner-store-credit" :class="{ error : chargeOnUser && credits === 0 }">
      <span><img class="mr-1" src="../../assets/Purchase/Bolt.svg"></span>
      <span v-if="chargeOnUser" class="text mr-1" v-text="`x`"/>
      <span class="text">
        {{ chargeOnUser ? credits : `Free` }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ScannerCard',
  props: {
    scanner: Object,
  },
  computed: {
    ...mapGetters('app', ['chargeOnUser']),
    ...mapGetters('user', ['credits']),
    isMobileScan() {
      return this.scanner.type === 'mobile';
    },
    isFootScanner() {
      return this.scanner.type === 'foot';
    },
    scannerTypeText() {
      if (this.isFootScanner) return this.$t('discovery.scanner__foot');

      if (this.isMobileScan) return this.$t('mobileScan.scanner_name');

      return this.$t('discovery.scanner__body');
    },
  },
};
</script>

<style lang="scss" scoped>
.card-root {
  @apply flex flex-col justify-center items-center p-5;
  padding: 10px;
  border-radius: 15px;
  box-shadow: 0 8px 20px 0 rgba(121, 121, 121, 0.25);
  background-color: #fff;
  &.mobile {
    background: rgba(233, 233, 255, 1);
  }
}
.scanner-icon-wrapper {
  @apply relative mx-auto my-3;
  @screen sm {
    @apply mt-auto;
  }
  width: 60%;
  min-width: 140px;
  height: 50%;
}
.scanner-type {
  @apply mx-auto text-center text-lg my-5;
  @screen sm {
    @apply text-2xl;
  }
}
.scanner-name {
  @apply text-sm;
  @screen sm {
    @apply mb-auto text-2xl;
  }
  color: #262626;
  opacity: 0.6;
}
.scanner-store-name {
  @apply text-sm;
  @screen sm {
    @apply mb-auto text-2xl;
  }
  color: #262626;
  opacity: 0.6;
}

.scanner-store-credit {
  @apply absolute top-0 right-0 px-3 py-2 text-sm flex flex-row items-center;
  @screen sm {
    @apply mb-auto text-2xl;
  }

  color: #d12c2d;
  &:not(.error) .text{
    background: linear-gradient(to right, #2245FF 0%, #540DEB 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>
